module.exports = __webpack_public_path__ + "img/zhong.848ef2a6.png";